<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-text>
        <v-flex xs12 class="mt-1">
          <v-data-table
            :headers="headers"
            :items="emrUsageHistoryList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{
                  props.item.createdDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ emrNo }}</td>
              <td>{{ props.item.productionNo }}</td>
              <td>{{ props.item.productCode }}</td>
              <td>
                {{ props.item.productName }}
              </td>
              <td>{{ props.item.factorUnitName }}</td>
              <td>{{ props.item.usageQty | decFormat(6) }}</td>
              <td>{{ props.item.createdBy }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { emrUsageHistoryService } from "../../services/emr-usage-history-service";

export default {
  name: "EMRUsageHistoryListDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      emrDetailId: "",
    },
    headers: [
      { text: "Date", align: "left", value: "createdDate" },
      { text: "EMR No", sortable: false },
      { text: "Production No", value: "productionHeader.issueNo" },
      { text: "Product Code", value: "product.code" },
      { text: "Product Name", value: "product.name" },
      { text: "Unit", sortable: false },
      { text: "Qty", value: "usageQty" },
      { text: "Created By", value: "createdBy" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "createdDate",
      totalItems: 0,
    },
    rowsPerPageItems: [10, 50, 100],
    totalRows: 0,
    emrUsageHistoryList: [],
    emrNo: "",
  }),
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose();
      },
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getEMRUsageHistoryList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          if (this.params.emrNo) {
            this.emrNo = this.params.emrNo;
          }
          if (this.params.emrDetailId) {
            this.queryParams.emrDetailId = this.params.emrDetailId;
            this.getEMRUsageHistoryList();
          }
        }
      },
    },
  },
  methods: {
    getEMRUsageHistoryList() {
      if (this.queryParams.emrDetailId) {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";
        emrUsageHistoryService
          .getEMRUsageHistoryList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            if (res.data) {
              this.emrUsageHistoryList = res.data.emrUsageHistoryList;
              this.totalItems = res.data.totalElements;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    dialogClose() {
      this.$emit("close");
    },
  },
};
</script>
